// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qhfEE","questions":"styles_questions__3EEHg","footer":"styles_footer__1n1lI"};